import React, { useEffect, useState,useRef } from 'react';
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import logisticsImg from "../assets/logistics.png"; // 📌 Replace with your actual image
import bgCircle from "../assets/bg-circle.png"; // optional purple background
import clockImg from "../assets/clock-delivery.png";
import chartImg from "../assets/efficiency-growth.png";
import customerImg from "../assets/customer-satisfaction.png";
import { Link } from 'react-router-dom';
import logo from "../assets/logo.svg";
import ind from "../assets/Ind.svg";
import dd from "../assets/DD.png";
import big from "../assets/Big.png";
import el from "../assets/EL.png";
import er from "../assets/ER.png";
import ec1 from "../assets/EC1.png";
import ec2 from "../assets/EC2.png";
import ep from "../assets/EP.png";
import tick from "../assets/Tick.svg";
import ar from "../assets/Ar.png";
import gr from "../assets/Gr.png";
// import a1 from "../assets/A1.png";
// import a2 from "../assets/A2.png";
// import a3 from "../assets/A3.png";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";
import k1 from "../assets/K1.png";
import k2 from "../assets/K2.png";
import k3 from "../assets/K3.png";
import k4 from "../assets/K4.png";
// import ll from "../assets/LL.png";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';
import { useNavigate } from 'react-router-dom'; 
import { toast, ToastContainer } from "react-toastify";
 


const Lo = () => {
 useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // 3s delay
    return () => clearInterval(timer);
  }, []);
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  const handleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
    const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );
 
      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };
const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };


   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
     const [isServicesOpen, setIsServicesOpen] = useState(false);
     const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
     const [isCompanyOpen, setIsCompanyOpen] = useState(false);
   
     const toggleMobileMenu = () => {
       setIsMobileMenuOpen(!isMobileMenuOpen);
     };
   
     const toggleServicesDropdown = () => {
       setIsServicesOpen(!isServicesOpen);
     };
   
     const toggleIndustriesDropdown = () => {
       setIsIndustriesOpen(!isIndustriesOpen);
     };
   
     const toggleCompanyDropdown = () => {
       setIsCompanyOpen(!isCompanyOpen);
     };
   


  const words = ['logistics', 'freight management'];
  
 const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true); // controls opacity

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000); // 1.4s display + 0.6s scroll

    return () => clearInterval(interval);
  }, []);



  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

 const benefitss = [
  {
    title: "Real-Time Visibility",
    description:
      "Our real-time tracking and monitoring technologies guarantee that businesses are always aware of the location, status, and condition of their shipments.",
    image: clockImg,
  },
  {
    title: "Operational Efficiency",
    description:
      "These efficiency advantages are essential in today's competitive market climate, where dependability, speed, and cost-effectiveness are critical factors.",
    image: chartImg,
  },
  {
    title: "Customer Satisfaction",
    description:
      "Our tracking projects ensure companies meet tight delivery deadlines, provide accurate arrival times, and resolve logistical issues quickly.",
    image: customerImg,
  },
];
  const benefits = [
  "Enhanced visibility and transparency",
  "Improved efficiency and productivity",
  "Cost savings",
  "Better customer services",
  "Enhanced security",
  "Data-driven insights",
];

const transformationDrivers = [
  {
    title: "Digitalization",
    icon: k1,
    description:
      "Digital technologies like automation, AI, and data analytics enhance logistics by improving decision-making, real-time tracking, and supply chain management.",
  },
  {
    title: "Automation",
    icon: k2,
    description:
      "Automation, including robotics and self-driving cars, is transforming logistics by reducing errors and increasing operational efficiency in warehouses.",
  },
  {
    title: "Sustainability",
    icon: k3,
    description:
      "Environmental concerns and regulations drive logistics to adopt sustainable practices like electric vehicles, reusable packaging, and route optimization.",
  },
  {
    title: "Globalization",
    icon: k4,
    description:
      "Global expansion drives demand for international logistics, requiring real-time visibility, compliance, and smarter coordination across borders.",
  },
];

 const drivers = [
    {
      title: "Digitalization",
      icon: k1,
      description:
        "Digital technologies like automation, AI, and data analytics enhance logistics by improving decision-making, real-time tracking, and supply chain management.",
    },
    {
      title: "Automation",
      icon: k2,
      description:
        "Automation, including robotics and self-driving cars, is transforming logistics by reducing errors and increasing operational efficiency in warehouses.",
    },
    {
      title: "Sustainability",
      icon: k3,
      description:
        "Environmental concerns and regulations drive logistics to adopt green practices like eco-friendly packaging, waste reduction, and energy-efficient delivery.",
    },
    {
      title: "Globalization",
      icon: k4,
      description:
        "Global expansion drives demand for international logistics, addressing complex supply chains, cross-border trade, and diverse regulatory challenges.",
    },
  ];
useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // change every 3s
    return () => clearInterval(interval);
  }, []);

//  

//   {
//     title: "Enhanced efficiency",
//     description:
//       "Automation and digital tools are cutting down on  operational expenses, expediting workflows, and eliminating delays. Deliveries become quicker and more dependable as a result, which is advantageous for both customers and companies.",
//   },
//   {
//     title: "Enhanced Visibility",
//     description:
//       "Businesses are able to watch the flow of goods, anticipate disruptions, and make well-informed decisions to reduce risks thanks to real-time tracking and data analytics, which offer a better understanding of the supply chain.",
//   },
//   {
//     title: "Customer Experience",
//     description:
//       "Businesses can provide better customer service, such as precise delivery dates, adaptable shipping alternatives, and quicker answers to queries, by implementing more transparent and efficient logistics processes.",
//   },
//   {
//     title: "Sustainable Practices",
//     description:
//       "As businesses move toward sustainability, they are able to reduce their environmental impact, lower operational costs, and satisfy increasing consumer demand for environmentally friendly goods and services.",
//   },
// ];

const FeatureCard = ({ title, items, bgColor, dotColor }) => (
  <div className={`rounded-2xl p-6 shadow-sm ${bgColor} w-full max-w-md`}>
    <h3 className="font-semibold text-xl mb-4 text-gray-900">{title}</h3>
    <ul className="space-y-3">
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-3">
          <span className={`mt-1 w-2.5 h-2.5 rounded-full ${dotColor}`}></span>
          <span className="text-sm text-gray-800 leading-snug">{item}</span>
        </li>
      ))}
    </ul>
  </div>
);


 const cardRefs = useRef([]);
const [visible, setVisible] = useState([]);

/* observe cards on scroll (in AND out) */
useEffect(() => {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const i = +e.target.dataset.index;
        if (e.isIntersecting) {
          // add index if not already there
          setVisible((prev) => (prev.includes(i) ? prev : [...prev, i]));
        } else {
          // remove index so the animation can run again next time
          setVisible((prev) => prev.filter((v) => v !== i));
        }
      });
    },
    { threshold: 0.15 }
  );

  cardRefs.current.forEach((el) => el && io.observe(el));
  return () => io.disconnect();
}, []);


const variants = {
  hiddenLeft: { opacity: 0, x: -80 },
  hiddenRight: { opacity: 0, x: 80 },
  hiddenUp: { opacity: 0, y: -80 },
  hiddenDown: { opacity: 0, y: 80 },
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};


const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,   // 0.25 s between cards – tweak as you like
    },
  },
};

/* each card’s own animation ---------------------------------------------------*/
const cardVariants = {
  hidden: { opacity: 0, y: 30 },         // start slightly below & transparent
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const logisticsBenefits = [
  {
    title: "Enhanced Efficiency",
    description:
      "Automation and digital tools are cutting down on operational expenses, expediting workflows, and eliminating delays. Deliveries become quicker and more dependable as a result, which is advantageous for both customers and companies.",
  },
  {
    title: "Enhanced Visibility",
    description:
      "Businesses are able to watch the flow of goods, anticipate disruptions, and make well-informed decisions to reduce risks thanks to real-time tracking and data analytics, which offer a better understanding of the supply chain.",
  },
  {
    title: "Customer Experience",
    description:
      "Businesses can provide better customer service, such as precise delivery dates, adaptable shipping alternatives, and quicker answers to queries, by implementing more transparent and efficient logistics processes.",
  },
  {
    title: "Sustainable Practices",
    description:
      "Digital logistics promotes eco-friendly practices, such as route optimization and reduced fuel consumption, helping companies reduce their carbon footprint and align with global sustainability goals.",
  },
];
  return (
    <div >
     <ToastContainer position="top-right" autoClose={3000} />

    <div className="top-0 z-50 w-full">
  <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
    
    {/* Left Emoji */}
    <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiLeft}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>

    {/* Center Text and Emojis */}
    <div className="flex flex-wrap items-center justify-center gap-1 px-6 text-center leading-tight">
      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

     <span className="text-[11px] sm:text-[12px] md:text-[13px] leading-tight">
  We are proud to announce that we have completed&nbsp;
  <span className="text-green-700 font-semibold">6 successful years!</span>
</span>

      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiParty} alt="Party" className="h-4 w-4 sm:h-5 sm:w-5" />
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>

    {/* Right Emoji */}
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiRight}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>
  </div>
</div>
 <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
            <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
              {/* Logo */}
              <div className="flex items-center space-x-2">
                <Link to="/">
                  <img
                    src={logo}
                    alt="Lentera Logo"
                    className="h-8 w-auto"
                  />
                </Link>
              </div>
      
              {/* Hamburger Icon for Mobile */}
              <button
                className="lg:hidden flex items-center"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <svg
                  className="h-6 w-6 text-gray-800"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={isMobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                  />
                </svg>
              </button>
      
              {/* Desktop Navigation */}
  <nav
      ref={navRef}
      className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
    >
      {/* --- Services Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('services');
            }}
          >
            Services
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'services' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/services/ai-services/", label: "AI Services" },
              { to: "/services/web-development/", label: "Web Development" },
              { to: "/services/mobile-app-development/", label: "Mobile App Development" },
              { to: "/services/software-consulting/", label: "Software Consulting" },
              { to: "/services/third-party-integration/", label: "Third Party Integration" },
              { to: "/services/custom-development/", label: "Custom Development" },
              { to: "/services/enterprise-application/", label: "Enterprise Application" },
              { to: "/services/digital-transformation/", label: "Digital Transformation" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Industries Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('industries');
            }}
          >
            Industries
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'industries' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              
              { to: "/industries/logistics/", label: "Logistics" },
              { to: "/industries/healthcare/", label: "Healthcare" },
              { to: "/industries/financial-services/", label: "Financial Services" },
              { to: "/industries/education/", label: "Education" },
              { to: "/industries/hospitality/", label: "Hospitality" },
              { to: "/industries/entertainment/", label: "Entertainment" },
              { to: "/industries/energy/", label: "Energy" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* --- Company Dropdown --- */}
      <div className="relative">
        <div className="flex items-center gap-1">
          <a
            href="#"
            className="text-black hover:text-black flex items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown('company');
            }}
          >
            Company
            <img
              src={dd}
              alt="Dropdown arrow"
              className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </a>
        </div>

        {openDropdown === 'company' && (
          <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              { to: "/company/our-advantages/", label: "Our advantages" },
              { to: "/company/our-story/", label: "Our Story" },
              { to: "/company/people-of-lentera/", label: "People of Lentera" },
              { to: "/company/our-brand/", label: "Our Brand" },
              { to: "https://blog.lentera.in/", label: "Blogs", external: true },
              { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              // { to: "/company/certifications/", label: "Certifications" },
            ].map((item) =>
              item.external ? (
                <a
                  key={item.to}
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </a>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                >
                  <div className="flex items-center">
                    <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span className="ml-2 text-xs">{item.label}</span>
                  </div>
                  <img
                    src={ar}
                    alt="Right arrow"
                    className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </Link>
              )
            )}
          </div>
        )}
      </div>

      {/* --- Contact Link --- */}
      <Link to="/contact/" className="text-black hover:text-black">
        Contact us
      </Link>
    </nav>
      
              {/* Desktop Language Selector + CTA */}
              <div className="hidden lg:flex items-center gap-3">
                {/* <button className="flex items-center gap-2 rounded-full border border-gray-300 px-4 py-1 text-sm font-medium text-gray-700 shadow-sm">
                  <img
                    src={ind}
                    alt="India Flag"
                    className="h-4 w-4 rounded-full"
                  />
                  India (English)
                  <ChevronDown className="h-4 w-4" />
                </button> */}
                <button
  onClick={handleClick}
  className="w-[175px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
>
  Get a Free Quote
</button>

              </div>
            </div>
      
            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link>
                         <Link
                          to="/services/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                       
                        <Link
                          to="/industries/logistics/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Logistics
                        </Link>
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                        <Link
                          to="/industries/energy/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Energy
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/our-story/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Story
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                        {/* <Link
                        to="/company/certifications/"
                        className="block px-4 py-2 text-xs hover:bg-gray-100"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Certifications
                      </Link>   */}
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          <button
                 onClick={handleClick}
  className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
  // onClick={() => {
  //   const section = document.getElementById("contact-section");
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // }}
>
  Get a Free Quote
</button>

                </nav>
              </div>
            )}
          </header>






        
   <section className="bg-[#E0FFE9] font-poppins w-full">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 px-6 py-16">
        {/* Text Section */}
        <div className="w-full md:w-6/12 text-center md:text-left">
          <p className="text-xs sm:text-sm font-semibold tracking-widest text-gray-900 mb-2">
            SUPPLY CHAIN & LOGISTICS
          </p>

          <h1 className="mb-6 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Redefining the future
            <br />
            of{" "}
            <span className="inline-block h-[70px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-[600ms] ease-in-out"
                style={{ transform: `translateY(-${index * 70}px)` }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[70px] flex items-center text-[#07862B] text-[32px] sm:text-[42px] md:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h1>

          <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Third-party integration uses external services and APIs to streamline
            supply chains. In today’s fast-changing logistics industry, digital
            transformation is essential.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          <img
            src={big}
            alt="Global logistics illustration"
            className="w-[90%] max-w-[400px] sm:max-w-[500px] md:max-w-[560px]"
          />
        </div>
      </div>
    </section>

  <section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
      {/* Top Heading and Paragraph */}
      <div className="max-w-[800px] mx-auto text-center mb-14">
        <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
          Advanced tracking in supply
          <br className="hidden sm:block" /> chain efficiency
        </h2>
        <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
          Advanced tracking uses technology to monitor and optimize supply chains. 
          <br className="hidden md:block" />
           It improves visibility, cuts delays, and reduces costs.
          
        </p>
      </div>

      {/* Card Grid */}
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefitss.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="flex flex-col items-center text-center border border-[#d3e1f6] rounded-[24px] bg-white p-8 shadow-sm hover:shadow-md transition-all min-h-[460px]"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-[348px] h-[208px] object-contain mb-6"
            />
            <h3 className="text-[20px] font-semibold text-[#1E1E1E] mb-4 leading-tight">
              {item.title}
            </h3>
            <p className="text-[#4B5563] text-[16px] leading-[26px]">
              {item.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>

<div className="bg-[#1A1A1A] text-white px-6 py-16 sm:px-8 md:px-12 lg:px-24">
  <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
    {/* Left Section */}
    <div>
      <button className="bg-black text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
        BENEFITS OVERVIEW
      </button>

      <h2 className="text-3xl sm:text-4xl font-bold mb-6 leading-tight">
        Benefits of our tracking <br />
        projects
      </h2>

      <p className="text-gray-300 text-sm mb-8 leading-relaxed">
        Our tracking initiatives provide a number of game-changing advantages that are <br />
        essential for contemporary freight and logistics management:
      </p>

      {/* Shuffling Benefits - Still Responsive */}
      <div className="flex flex-wrap gap-4">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="flex items-center gap-2 bg-[#3A3A3A] px-4 py-2 rounded-full"
          >
            <img src={tick} alt="tick" className="w-5 h-5" />
            <span className="font-semibold text-white text-sm whitespace-nowrap">
              {benefit}
            </span>
          </div>
        ))}
      </div>
    </div>

    {/* Right Section */}
    <div className="flex justify-center lg:justify-end">
      <img
        src={gr}
        alt="Illustration"
        className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-xs xl:max-w-sm"
      />
    </div>
  </div>
</div>



     <div className="bg-white text-center px-6 py-16 md:px-12">
      <h2 className="text-3xl md:text-5xl font-medium text-[#1A1A1A] leading-snug mb-6">
        Tracking encouraging operational <br className="hidden md:block" />
        excellence
      </h2>
      <p className="text-gray-600 text-[12px] md:text-[15px] max-w-3xl mx-auto">
        Tracking promotes operational excellence by providing real-time data for smarter <br/>  decisions.
        It enhances efficiency, accuracy, and responsiveness across the supply chain.
      </p>
    </div>
<div className="relative bg-white py-16 px-4 sm:px-8 lg:px-20 overflow-hidden -mt-10">
  {/* Background shapes */}
  
  <div className="relative z-10 mx-auto grid max-w-4xl gap-8 md:grid-cols-2">
      {/* 1 — from left */}
      <motion.div
        variants={variants}
        initial="hiddenLeft"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Tracking solutions"
          items={[
            "Commitment to innovation & technology",
            "Reliable tracking solutions",
            "Improved supply chain visibility & efficiency",
            "Enhanced customer satisfaction",
          ]}
          bgColor="bg-rose-100"
          dotColor="bg-rose-400"
        />
      </motion.div>

      {/* 2 — from top */}
      <motion.div
        variants={variants}
        initial="hiddenUp"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Empowering operational efficiency"
          items={[
            "Accurate and reliable optimization of logistics operations",
            "Real-time shipment status analytics",
            "Proactive decision-making support",
            "Prompt action to minimize disruptions",
          ]}
          bgColor="bg-purple-200"
          dotColor="bg-purple-500"
        />
      </motion.div>

      {/* 3 — from bottom */}
      <motion.div
        variants={variants}
        initial="hiddenDown"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Dedication to Superiority"
          items={[
            "Commitment to innovation, scalability, and dependability",
            "Pursuit of operational excellence",
            "Ability to foresee market trends and tackle new challenges",
            "Establishing as a reliable partner in global supply chain optimization",
          ]}
          bgColor="bg-yellow-100"
          dotColor="bg-yellow-400"
        />
      </motion.div>

      {/* 4 — from right */}
      <motion.div
        variants={variants}
        initial="hiddenRight"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Client centric approach"
          items={[
            "Ensure fulfillment of demanding delivery deadlines",
            "Provide clients with precise arrival times",
            "Quickly handle logistical issues",
            "Support reliable tracking through advanced systems",
          ]}
          bgColor="bg-green-100"
          dotColor="bg-green-400"
        />
      </motion.div>
    </div>
</div>


    
<section className="bg-[#FFF2B2] py-20 px-4 sm:px-6 lg:px-12">
  {/* Section Heading */}
  <div className="max-w-6xl mx-auto text-center mb-12">
    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
      Key drivers of transformation
    </h2>
    <p className="mt-4 text-gray-700 max-w-2xl mx-auto text-base md:text-lg">
      Several key factors are driving the transformation of logistics,
      including technological advances, market demands, and evolving customer
      expectations.
    </p>
  </div>

  {/* Grid Cards */}
  <div className="flex flex-wrap justify-center gap-6">
    {transformationDrivers.map((item, idx) => (
      <div
        key={idx}
        className="bg-white rounded-3xl shadow-sm p-6 flex flex-col justify-start w-[520px] h-[237px]"
      >
        <img src={item.icon} alt={item.title} className="w-12 h-12 mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {item.title}
        </h3>
        <p className="text-sm text-gray-700 leading-relaxed">
          {item.description}
        </p>
      </div>
    ))}
  </div>
</section>


<section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
      <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        
        {/* Left side: Text + Image */}
        <div className="w-full lg:w-[48%] relative flex flex-col items-center lg:items-start text-center lg:text-left">
          <h2 className="text-[28px] sm:text-[36px] md:text-[44px] font-semibold text-[#1E1E1E] leading-tight mb-6">
            Significantly impact by the logistics transformation
          </h2>
          <p className="text-[#4B5563] text-[16px] sm:text-[18px] leading-[28px] mb-10 max-w-[600px]">
            Logistics transformation is driving major improvements in speed, accuracy, and efficiency across supply chains. It significantly impacts how businesses operate, compete, and deliver value to customers.
          </p>

          {/* Responsive Background Circle (optional) */}
          <div className="absolute top-[50%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] sm:w-[320px] md:w-[400px] h-auto opacity-20 pointer-events-none z-0">
            {/* <img
              src={bgCircle}
              alt=""
              className="w-full h-auto"
            /> */}
          </div>

          
         {/* Main Logistics Image */}
<div className="relative z-10 w-full max-w-[400px] sm:max-w-[460px] md:max-w-[500px] mx-auto lg:mx-0 flex justify-center items-center">
  <img
    src={logisticsImg}
    alt="Logistics"
    className="w-full h-auto object-contain"
  />
</div>

        </div>

        {/* Right side: Animated cards */}
        <div className="w-full lg:w-[50%] flex flex-col gap-6">
          {logisticsBenefits.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: false, amount: 0.4 }}
              className="bg-[#F4F9FF] p-5 sm:p-6 rounded-[20px] shadow-sm"
            >
              <h3 className="text-[18px] sm:text-[20px] font-semibold text-[#1E1E1E] mb-2">
                {item.title}
              </h3>
              <p className="text-[#4B5563] text-[15px] sm:text-[16px] leading-[24px] sm:leading-[26px]">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>

    <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="http://localhost:3000/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
          <div className="flex items-start gap-3 mb-3">
  <img src={phone} alt="phone" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Phone number</p>
    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
      +91-44-4856-3345
    </a>
  </div>
</div>

<div className="flex items-start gap-3 mb-3">
  <img src={mail} alt="email" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Email address</p>
    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
      info@lenteratech.com
    </a>
  </div>
</div>

           <div className="flex items-start gap-3">
  <img src={loc} alt="location" className="w-5 h-5 mt-1" />
  <div>
    <p className="text-[#999] text-sm">Location</p>
    <a
      href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white font-medium text-sm hover:underline block"
    >
      G1, Plot No, 824 and 826, 3rd<br />
      Main Rd, Ram Nagar South,<br />
      Madipakkam, Chennai,<br />
      Tamil Nadu 600091
    </a>
  </div>
</div>

         </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>

    </div>
  )
}

export default Lo